<template>
  <div class="row g-3 mt-3">
    <div class="col-12 col-md-6">
      <select class="form-control" v-model="filter.accountIds" multiple>
        <option value="" v-if="accounts.length > 1">Все</option>
        <option
            v-for="acc in accounts"
            :key="acc.id"
            :value="acc.id"
        >
          {{ acc.name }}
        </option>
      </select>
    </div>

    <div class="col-12 col-md-6">
      <div class="d-flex flex-column gap-3 pt-1">
        <div class="d-flex align-items-center gap-2">
          <span class="filter-label">От</span>
          <input
              class="form-control"
              v-model="filter.createdAtFrom"
              type="datetime-local"
          />
        </div>

        <div class="d-flex align-items-center gap-2">
          <span class="filter-label">До</span>
          <input
              class="form-control"
              v-model="filter.createdAtTo"
              type="datetime-local"
          />
        </div>
      </div>
    </div>

    <div class="col-12 d-flex justify-content-start">
      <div class="d-flex gap-3 mt-2">
        <button class="btn btn-primary" @click="applyFilter">
          Фильтр
        </button>

        <button class="btn btn-outline-primary" @click="clearFilter">
          Сбросить
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {reactive, watch} from "vue";

const props = defineProps({
  accounts: { type: Array, required: true },
  initial: { type: Object, required: true },
});

const emit = defineEmits(['applyFilter', 'clearFilter']);

const filter = reactive({
  accountIds: props.initial.accountIds ?? [],
  createdAtFrom: props.initial.createdAtFrom ?? '',
  createdAtTo: props.initial.createdAtTo ?? '',
});

watch(
    () => props.initial,
    (init) => {
      filter.accountIds = init.accountIds ?? [];
      filter.createdAtFrom = init.createdAtFrom ?? '';
      filter.createdAtTo = init.createdAtTo ?? '';
    },
    { immediate: true, deep: true }
)

const applyFilter = () => {
  emit('applyFilter', filter);
};

const clearFilter = () => {
  filter.accountIds = [];
  filter.createdAtFrom = '';
  filter.createdAtTo = '';
  emit('clearFilter', filter);
};
</script>

<style scoped>
.filter-label {
  min-width: 22px;
}
</style>